import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Stack from "@mui/material/Stack";
import LearnTextEmbed from "../../LearnPanelComponents/LearnCopy/LearnTextEmbed";

type CallToActionBoxProps = {
  title: string;
  description: string;
  buttonText: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  urgent?: boolean;
};

function CallToActionBox(props: CallToActionBoxProps) {
  const buttonProps = {
    variant: props.urgent ? ("contained" as const) : ("outlined" as const),
    size: "large" as const,
    color: props.urgent ? ("warning" as const) : ("info" as const),
    disabled: props.disabled,
    onClick: props.onClick,
    endIcon: <ArrowForwardIcon />,
    sx: { whiteSpace: "nowrap" },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Typography variant="h5" noWrap sx={{ color: "info.main" }}>
        {props.title}
      </Typography>
      <Stack direction="row" flexWrap="wrap" sx={{ justifyContent: "space-between", gap: 1 }}>
        <Typography component="div" variant="body1" color="text.secondary">
          <LearnTextEmbed content={props.description} />
        </Typography>
        <Box textAlign="right" sx={{ flexGrow: 1, alignItems: "flex-end" }}>
          {props.loading === undefined ? (
            <Button {...buttonProps}>{props.buttonText}</Button>
          ) : (
            <LoadingButton {...buttonProps} loading={props.loading}>
              {props.buttonText}
            </LoadingButton>
          )}
        </Box>
      </Stack>
    </Box>
  );
}

export default CallToActionBox;
